/**
 * Pinia Store 入口：持久化 + 全局 withLoading / init
 */
import { createPinia } from 'pinia'
import { nextTick } from 'vue'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import Message from '@/utils/web/message.js'

/** 为每个 store 挂载 withLoading，并在 nextTick 自动调用用户定义的 init */
function storeUtilsPlugin({ store }) {

    store.withLoading = async function (asyncFn, options = {}) {
        const {
            silent = false,
            errorMessage = '操作失败',
            loadingKey = 'loading'
        } = options
        const hasLoading = loadingKey in store.$state
        if (hasLoading) {
            store[loadingKey] = true
        }
        try {
            return await asyncFn()
        } catch (error) {
            Message.error(errorMessage, error)
            if (!silent) {
                throw error
            }
            return null
        } finally {
            if (hasLoading) {
                store[loadingKey] = false
            }
        }
    }

    const DEFAULT_INIT_MARKER = Symbol('defaultInit')
    const defaultInit = function () { }
    defaultInit[DEFAULT_INIT_MARKER] = true
    if (!store.init) {
        store.init = defaultInit
    }
    nextTick(() => {
        const isUserDefinedInit = !store.init[DEFAULT_INIT_MARKER]
        if (isUserDefinedInit) {
            try {
                store.init()
            } catch (error) {
                console.error(`[${store.$id}] init 方法执行失败:`, error)
            }
        }
    })
}

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
pinia.use(storeUtilsPlugin)

export default pinia